import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
export default function () {
    function onClick1(title, message, buttons, uibuttons, message_class, message_color, button, buttonIndex, e) {
        {
            button.onClick(e, button);
        }
    }
    function repeatButton2(title, message, buttons, uibuttons, message_class, message_color, button, buttonIndex) {
        return React.createElement('div', { 'key': button.text }, React.createElement('div', { 'onClick': onClick1.bind(this, title, message, buttons, uibuttons, message_class, message_color, button, buttonIndex) }, React.createElement('div', { className: 'message-' + this.getAlertClassType() + '-dismiss-button' }, React.createElement('span', { 'className': 'message-box-button-primary' }, '\r\n              ', button.text, '\r\n            '), button.subtext && button.subtext.length > 0 ? React.createElement('span', {
            'className': 'message-box-button-secondary',
            'key': '1174'
        }, '\r\n              ', button.subtext, '\r\n            ') : null)));
    }
    function onClick3(title, message, buttons, uibuttons, message_class, message_color, uibutton, uibuttonIndex, e) {
        {
            uibutton.onClick(e, uibutton);
        }
    }
    function repeatUibutton4(title, message, buttons, uibuttons, message_class, message_color, uibutton, uibuttonIndex) {
        return React.createElement('button', {
            'onClick': onClick3.bind(this, title, message, buttons, uibuttons, message_class, message_color, uibutton, uibuttonIndex),
            'className': classNames('ui-button', 'ui-button--' + message_color),
            'key': uibutton.text
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, uibutton.text));
    }
    function scopeTitleMessageButtonsUibuttonsMessage_classMessage_color5() {
        var title = this.props.title || 'Error';
        var message = this.props.message;
        var buttons = this.props.buttons;
        var uibuttons = this.props.uibuttons;
        var message_class = this.getAlertClassType();
        var message_color = this.getAlertColor();
        return React.createElement('div', {
            'className': 'message-box-overlay',
            'key': '66'
        }, React.createElement('div', { 'className': 'message-window-base' }, React.createElement('div', { className: 'message-' + message_class + '-message-title' }, title), React.createElement('div', { className: 'message-' + message_color + '-lable' }), React.createElement('div', { className: 'message-system-text message-system-text-' + this.getAlertColor() }, '\r\n      ', message, '\r\n    '), React.createElement.apply(this, [
            'div',
            { 'className': classNames('message-box-buttons', { 'message-box-buttons--modal': !!uibuttons }) },
            _.map(buttons, repeatButton2.bind(this, title, message, buttons, uibuttons, message_class, message_color)),
            _.map(uibuttons, repeatUibutton4.bind(this, title, message, buttons, uibuttons, message_class, message_color))
        ])));
    }
    return this.props.visible ? scopeTitleMessageButtonsUibuttonsMessage_classMessage_color5.apply(this, []) : null;
}